// @flow

import React from 'react';

import notification from 'antd/lib/notification';

import { measuringDeviceCertificationApi } from '../../../../../lib/api';
import type { MeasuringDeviceCertification } from '../../../../../lib/types';

import Filter from '../../../../services/measuringDeviceCertification/Filter';
import { MEASURING_DEVICE_CERTIFICATION_COLUMNS } from '../../../../services/measuringDeviceCertification';

import { ListTable } from '../../../lib';

export default class extends ListTable<MeasuringDeviceCertification> {
  fetch = async (page: number = 1) => {
    const params = super.fetch(page);
    try {
      const data = await measuringDeviceCertificationApi.fetchMeasuringDeviceCertifications(
        params
      );
      const totalSum = await measuringDeviceCertificationApi.getTotalSum(
        params
      );
      this.setState({ ...data, totalSum, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        {super.renderFilter(Filter)}
        {super.renderTable(MEASURING_DEVICE_CERTIFICATION_COLUMNS)}
      </>
    );
  }
}
